import { Component, Input, OnInit } from '@angular/core';

import { ITimelineItem } from '../models/timeline-item';

interface IEventDetail
{
    style: string;
    icon: string;
    title: string;
    side: string;
}

const eventDetails: Map<string, IEventDetail> = new Map<string, IEventDetail>(
    [
        [
            'default',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'cog',
                'title': ''
            } as IEventDetail
        ],
        [
            'create',
            {
                'side': 'left',
                'style': 'success',
                'icon': 'plus',
                'title': 'Created'
            } as IEventDetail
        ],
        [
            'start',
            {
                'side': 'right',
                'style': 'success',
                'icon': 'play',
                'title': 'Started'
            } as IEventDetail
        ],
        [
            'stop',
            {
                'side': 'right',
                'style': 'danger',
                'icon': 'stop',
                'title': 'Stopped'
            } as IEventDetail
        ],
        [
            'reboot',
            {
                'side': 'left',
                'style': 'success',
                'icon': 'play',
                'title': 'Rebooted'
            } as IEventDetail
        ],
        [
            'unpause',
            {
                'side': 'right',
                'style': 'success',
                'icon': 'play',
                'title': 'Unpaused'
            } as IEventDetail
        ],
        [
            'pause',
            {
                'side': 'right',
                'style': 'warning',
                'icon': 'pause',
                'title': 'Paused'
            } as IEventDetail
        ],
        [
            'live-migration',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'arrow-up',
                'title': 'Live Migration'
            } as IEventDetail
        ],
        [
            'delete',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'trash',
                'title': 'Delete'
            } as IEventDetail
        ],
        [
            'evacuate',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Evacuate'
            } as IEventDetail
        ],
        [
            'restore',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Restore'
            } as IEventDetail
        ],
        [
            'rebuild',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Rebuild'
            } as IEventDetail
        ],
        [
            'revertResize',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Revert Resize'
            } as IEventDetail
        ],
        [
            'confirmResize',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Confirm Resize'
            } as IEventDetail
        ],
        [
            'resize',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Resize'
            } as IEventDetail
        ],
        [
            'migrate',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Migration'
            } as IEventDetail
        ],
        [
            'suspend',
            {
                'side': 'right',
                'style': 'info',
                'icon': 'info',
                'title': 'Suspend'
            } as IEventDetail
        ],
        [
            'resume',
            {
                'side': 'right',
                'style': 'info',
                'icon': 'info',
                'title': 'Resume'
            } as IEventDetail
        ],
        [
            'rescue',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Rescue'
            } as IEventDetail
        ],
        [
            'unrescue',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Unrescue'
            } as IEventDetail
        ],
        [
            'changePassword',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Change password'
            } as IEventDetail
        ],
        [
            'shelve',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Shelve'
            } as IEventDetail
        ],
        [
            'unshelve',
            {
                'side': 'left',
                'style': 'info',
                'icon': 'info',
                'title': 'Unshelve'
            } as IEventDetail
        ],
        [
            'attach_interface',
            {
                'side': 'right',
                'style': 'info',
                'icon': 'cog',
                'title': 'Attach interface'
            } as IEventDetail
        ]
    ]
);

@Component({
    selector: 'aa-timeline-item',
    templateUrl: './timeline-item.component.html',
    styleUrls: [
        './timeline-item.component.scss'
    ],
    standalone: false
})
export class TimelineItemComponent implements OnInit
{
    @Input() tlItem: ITimelineItem;
    public evtDetail: IEventDetail;

    ngOnInit ()
    {
        this.evtDetail = eventDetails.has(this.tlItem.eventType) ? eventDetails.get(this.tlItem.eventType) : eventDetails.get('default');
    }
}
